import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import i18n from 'i18next';

if(!localStorage.getItem("selectedLanguage")){
  localStorage.setItem("selectedLanguage", 0);
}
i18n.changeLanguage(localStorage.getItem("selectedLanguage"));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode> 
      <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
